var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeMenuIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    "data-name": "\\u5716\\u5C64 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0610_\u5F8C\u53F0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,12A12,12,0,0,1,12,24H12A12,12,0,0,1,0,12H1.88A10.12,10.12,0,0,0,12,22.13H12A10.13,10.13,0,1,0,4.71,5H6.56V6.84H1.41V1.69H3.28V3.75A12,12,0,0,1,24,12Zm-14.6.27A3.66,3.66,0,1,1,15.75,9.8a3.68,3.68,0,0,1-1,2.47,5.63,5.63,0,0,1,2.93,4.93H15.84a3.75,3.75,0,0,0-7.5,0H6.47A5.61,5.61,0,0,1,9.4,12.27Zm2.69-.69A1.78,1.78,0,1,0,10.31,9.8,1.79,1.79,0,0,0,12.09,11.58Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMenuIcon2);
export default __webpack_public_path__ + "static/media/homeMenuIcon2.45b7758453cfa841cc4cc212d3a31ac9.svg";
export { ForwardRef as ReactComponent };